import React from 'react';
import useSchemaStore from '../../store/schemaStore';

const TableMetaData = () => {
  const { tableCommentAdded, tableComment, updateTableComment, tableEngine, updateTableEngine, tableResource, updateTableResource, migrateTable, updateMigrateTable, removeTableMetadata } = useSchemaStore();
  return (
      <>
      {tableCommentAdded && (
          <table className="indices table mt-4">
            <thead>
              <tr>
                <th>💾 Table Comment</th>
                <th>
                  Engine <span className="infolink">
                    <span className="infotext">
                      <b>InnoDB</b>: Use this engine for most tables in Magento,
                      especially those that require data integrity, support for
                      transactions, and relationships between tables.
                      <br />
                      <br />
                      <b>Memory</b>: Use this engine for tables that need to be
                      accessed quickly and where data loss is acceptable, such
                      as temporary storage for session data or caching.
                    </span>
                  </span>
                </th>
                <th>
                  Resource <span className="infolink">
                    <span className="infotext">
                      <b>Resource</b> attribute is used to specify the database
                      shard where a particular table should be created.
                      <br />
                      <br />
                      By directing specific tables to different database shards,
                      Magento can distribute database load more efficiently.
                      This is particularly useful in high-traffic environments
                      where separating checkout and sales data from the main
                      database can help prevent bottlenecks.
                      <br />
                      <br />
                      <b>default</b>: For general-purpose tables.
                      <br />
                      <b>checkout</b>: For tables related to the checkout
                      process.
                      <br />
                      <b>sales</b>: For tables handling sales order data
                    </span>
                  </span>
                </th>
                <th>
                  Migrate Data From <span className="infolink">
                    <span className="infotext">
                      This is a DML trigger that allows you to move data from an
                      existing table to a newly created table. This trigger
                      works only when a table is created.
                    </span>
                  </span>
                </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <input
                    type="text"
                    placeholder="Table comment (optional)"
                    className="form-control"
                    name="tableComment"
                    value={tableComment}
                    onChange={(e) => updateTableComment(e.target.value)}
                  />
                </td>
                <td>
                  <select
                    aria-label="Table Engine"
                    className="form-control"
                    name="tableEngine"
                    value={tableEngine}
                    onChange={(e) => updateTableEngine(e.target.value)}
                  >
                    <option value="">Select Engine</option>
                    <option value="innodb">innodb</option>
                    <option value="memory">memory</option>
                  </select>
                </td>
                <td>
                  <select
                    aria-label="Table Resource"
                    className="form-control"
                    name="tableResource"
                    value={tableResource}
                    onChange={(e) => updateTableResource(e.target.value)}
                  >
                    <option value="">Select Resource</option>
                    <option value="default">default</option>
                    <option value="checkout">checkout</option>
                    <option value="sales">sales</option>
                  </select>
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="tablename"
                    className="form-control"
                    name="migrateTable"
                    value={migrateTable}
                    onChange={(e) => updateMigrateTable(e.target.value)}
                  />
                </td>
                <td>
                  <button
                    className="btn btn-danger"
                    onClick={() => removeTableMetadata()}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </>
  );
};

export default TableMetaData;